export const fileToString = (file: File): Promise<string> => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((res, rej) => {
        reader.onload = function () {
            const result = reader.result;
            typeof result === 'string' ? res(result) : rej('');
        };
        reader.onerror = function () {
            rej('');
        };
    });
};
